import { IconCheck, IconX } from 'featherico';
import { isFeatureEnabled } from '../../../services/Features';
import Button from '../../Button';
import { Card, CardHeader, CardHeaderButtons, CardHeaderHeading, CardSection, CardSectionBody } from '../../Cards';
import ButtonWithUpgradePlanModal from '../ButtonWithUpgradePlanModal';
import style from './styles.m.less';

interface Props {
    onDismiss: () => void;
}

export default function UpgradePlanPanel({ onDismiss }: Props) {
    if (!isFeatureEnabled('surveys-basic-mode')) {
        return null; // Hide the spark if full surveys is already available
    }

    return (
        <Card className={style.panelContainer}>
            <CardHeader>
                <CardHeaderHeading>Elevate Your SI Experience</CardHeaderHeading>
                <CardHeaderButtons>
                    <Button onClick={onDismiss} kind="PLAIN" className={style.dismissButton}>
                        <IconX />
                    </Button>
                </CardHeaderButtons>
            </CardHeader>
            <CardSection>
                <CardSectionBody>
                    <p>Enhance your productivity now! 🚀</p>
                    <ul className={style.list}>
                        <li className={style.listItem}>
                            <IconCheck />
                            Advanced feedback tools and team engagement features
                        </li>
                        <li className={style.listItem}>
                            <IconCheck />
                            In-depth analytics and unlimited surveys
                        </li>
                        <li className={style.listItem}>
                            <IconCheck />
                            Full customization and enhanced integrations
                        </li>
                    </ul>
                    <ButtonWithUpgradePlanModal
                        disabled={true}
                        TriggerButton={() => <Button kind="PRIMARY">Upgrade Now</Button>}
                        showUpgradeIcon={false}
                    />
                </CardSectionBody>
            </CardSection>
        </Card>
    );
}
